import Grange from "../assets/images/grange-sch.png";
import GrangeLogo from "../assets/images/grange.png";
import Doveland from "../assets/images/doveland-sch.png";
import DovelandLogo from "../assets/images/doveland.png";
import Starvile from "../assets/images/starvile-sch.png";
import StarvileLogo from "../assets/images/starvile2.png";

export const StoriesInfo = [
  {
    schImg: Grange,
    schLogo: GrangeLogo,
    storyTitle: "Transforming Education Management: A Partnership with educare",
    storyParagraph:
      "educare has been a true partner in shaping the educational experience at Grange School. With their innovative suite of platforms, our administrative tasks have become a breeze, allowing us to focus on what truly matters: educating the leaders of tomorrow. From streamlining HR management to ensuring efficient facility upkeep, educare has exceeded our expectations. Their commitment to excellence is evident in their top-notch customer support and continuous updates. educare truly empowers our educators to make a difference.",
    storyLink: "",
    testifier: "IT Manager",
  },
  {
    schImg: Doveland,
    schLogo: DovelandLogo,
    storyTitle:
      "Fostering Innovation: educare's Revolution in School Management",
    storyParagraph:
      "educare has transformed the way we manage our school operations. Their software has seamlessly integrated all aspects of our school, from HR to daily reporting and analytics. We can now make data-driven decisions that enhance the learning experience for our students. The calendar platform has simplified scheduling, ensuring smooth coordination for events and activities. educare's commitment to education shines through in their user-friendly interface and dedicated support team. It's not just a software solution; it's a tool that empowers us to create a brighter future for our students.",
    storyLink: "",
    testifier: "Head of Operations",
  },
  {
    schImg: Starvile,
    schLogo: StarvileLogo,
    storyTitle: "Empowering Growth: educare's Impact on Starville School ",
    storyParagraph:
      "As an institution focused on nurturing innovation and creativity, educare has been a perfect fit for us. Their software suite has revolutionized the way we manage our school, enabling us to maintain a progressive learning environment. From efficient HR management to insightful analytics, educare has streamlined our processes, allowing us to concentrate on fostering innovation in our students. Their commitment to education and technology is truly commendable, and we're proud to have educare as a partner in our journey.",
    storyLink: "",
    testifier: "Director",
  },
];
